import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CommentsAndDocumentsCollection } from '../../Models/Domains/Workflow/CommentsAndDocumentsCollection';
import { DemandType } from '../../Models/Domains/Workflow/DemandType';

declare var IS_RUNNING_IN_APP_POOL;

export class CommentsAndDocumentsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(caseDataId: number, demandType: DemandType, caseGroupSequenceNumber: number, sequenceNumber: number, start: number, count: number): Promise<CommentsAndDocumentsCollection, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/CommentsAndDocuments/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { caseDataId: caseDataId, demandType: demandType, caseGroupSequenceNumber: caseGroupSequenceNumber, sequenceNumber: sequenceNumber, start: start, count: count }

    return AjaxWrapper.get<CommentsAndDocumentsCollection, any>(url, data);
  }
}

